(() => {
  if (customElements.get('product-share')) return;

  class ProductShare extends HTMLElement {
    connectedCallback() {
      if (this.button) return;
      this.button = this.querySelector('button');
      this.label = this.querySelector('[data-share-label]');
      this.status = this.querySelector('[data-share-status]');
      this.fallback = this.querySelector('.product-share__fallback');
      this.linkInput = this.fallback.querySelector('input');
      this.defaultLabel = this.label.textContent;
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.share());
      this.linkInput.addEventListener('click', () => this.linkInput.select());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.fallback.hidden = true;
          this.button.focus();
        }
      });
    }

    getShareData() {
      const root = this.closest('.product-template__container') || this.parentElement.parentElement;
      const form = document.getElementById(this.dataset.formId) || root.querySelector('form[action*="/cart/add"]');
      const picker = form?.querySelector('product-variant-swatch, product-variant-dropdown');
      let variantId = form?.querySelector('[name="id"]')?.value || this.dataset.defaultVariantId;
      let optionValueIds = [];
      let description = '';

      if (picker) {
        const variants = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
        const current = variants.find((item) => String(item.id) === String(variantId)) || variants[0];
        // Match by option name so reordered controls and extra fieldsets cannot block sharing.
        const controls = Array.from(picker.querySelectorAll('input[type="radio"], select'));
        const selected = JSON.parse(this.dataset.optionNames).map((name, index) => {
          const group = controls.filter((input) => input.name === name || input.name === `options[${name}]`);
          return group.find((input) => input.checked || input.tagName === 'SELECT')
            || group.find((input) => input.value === current.options[index]);
        });
        const options = selected.map((input, index) => input?.value || current.options[index]);
        optionValueIds = selected.map((input) => (input?.selectedOptions?.[0] || input)?.dataset.optionValueId);
        const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
        // option_values also preserves combinations without a purchasable variant.
        variantId = variant?.id;
        description = variant?.title === 'Default Title' ? '' : options.join(' / ');
      }

      // Start with the public product URL so theme-preview and tracking parameters never leak.
      const url = new URL(this.dataset.productUrl);
      if (variantId) url.searchParams.set('variant', variantId);
      else if (optionValueIds.length && optionValueIds.every(Boolean)) {
        url.searchParams.set('option_values', optionValueIds.join(','));
      }
      return { title: this.dataset.productTitle, text: [this.dataset.productTitle, description].filter(Boolean).join(' — '), url: url.href };
    }

    announce(message, label = this.defaultLabel) {
      clearTimeout(this.resetTimer);
      this.status.textContent = message;
      this.label.textContent = label;
      this.resetTimer = setTimeout(() => {
        this.label.textContent = this.defaultLabel;
        this.status.textContent = '';
      }, 3000);
    }

    async copyLink(url) {
      try {
        await navigator.clipboard.writeText(url);
      } catch (_) {
        this.linkInput.value = url;
        this.fallback.hidden = false;
        this.linkInput.focus();
        this.linkInput.select();
        // Support browsers where the async Clipboard API is unavailable or denied.
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (_) {
          // The selected link remains available for manual copying.
        }
        if (!copied) {
          this.announce('Copy the link below.');
          return;
        }
        this.fallback.hidden = true;
        this.button.focus();
      }
      this.announce('Link copied', 'Link copied');
    }

    async share() {
      if (this.sharing) return;
      const data = this.getShareData();
      this.sharing = true;
      this.fallback.hidden = true;
      try {
        await this.copyLink(data.url);
      } finally {
        this.sharing = false;
      }
    }

    disconnectedCallback() {
      clearTimeout(this.resetTimer);
    }
  }

  customElements.define('product-share', ProductShare);
})();
